import ENV from 'browser-environment';

import DOM from '@/scripts/old/modules/jqueryDOM';

function Tooltip() {
  // TODO: align on hover by screen borders
  if (ENV.touchScreen) {
    DOM.$document.on('click', '.js-tooltip', function toggleTooltip() {
      $(this).toggleClass('is-show');
    });
  }
}

export default new Tooltip();
